import * as yup from 'yup';

export const restorePasswordValidationSchema = yup.object().shape({
    email: yup.string().email('incorrectEmail').required('required'),
});
